import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { ParamGeneralFieldDto, ParamGeneralStatus } from '@/types';

export interface ParamGeneralFieldProps {
  dto: ParamGeneralFieldDto;
  typeSelected: SelectOption;
  statusSelected: SelectOption;
  sourceSelected: SelectOption;
  sourceFieldSelected: SelectOption;
  errors: Record<string, any>;
}

export const paramGeneralFieldInitialState: ParamGeneralFieldProps = {
  dto: {
    id: undefined,
    paramGeneralName: '',
    paramGeneralLabel: '',
    paramGeneralDescription: '',
    paramGeneralType: undefined,
    paramGeneralOrder: 1,
    paramGeneralSource: '',
    paramGeneralSourceField: '',
    paramGeneralStatus: ParamGeneralStatus.ACTIF,
  },
  typeSelected: { name: '', code: undefined },
  statusSelected: { name: 'Actif', code: ParamGeneralStatus.ACTIF },
  sourceSelected: { name: '', code: undefined },
  sourceFieldSelected: { name: '', code: undefined },
  errors: {},
};

export const paramGeneralFieldStoreFactory = (id: string) => {
  return createStore({ name: `param-general-field-state-${id}` }, withProps<ParamGeneralFieldProps>(structuredClone(paramGeneralFieldInitialState)));
};
